<template>
  <div class="header-search">
    header-search
  </div>
</template>

<script>
  export default {
    name: "HeaderSearch"
  }
</script>

<style scoped>

</style>